module.exports = __webpack_public_path__ + "img/g2.9b75c521.png";